import { render, staticRenderFns } from "./SolicitacaoHistorico.vue?vue&type=template&id=18038084&"
import script from "./SolicitacaoHistorico.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoHistorico.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoHistorico.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports